module.exports = __webpack_public_path__ + "img/categories-and-zones.8a2c10dd.svg";